import { FixedIncomeOrderBuyEntity, FundOrderBuyEntity } from '@genial/services';
import { useBreakpointValue } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';
import { StyleSheet } from 'react-native';

import { SectionContainer } from '../SectionContainer';
import { SectionItem } from '../SectionItem';

import { createSectionOrderItems } from './constants';

export interface OrderSectionProps extends FixedIncomeOrderBuyEntity, FundOrderBuyEntity {}

const style = StyleSheet.create({
  columnWrapper: { justifyContent: 'space-between' },
});

export const OrderSection: React.FC<OrderSectionProps> = (props) => {
  const sectionItems = createSectionOrderItems(props);
  const numColumns = useBreakpointValue({ base: 1, sm: 3, lg: sectionItems.length || 3 });
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const columnWrapperStyle = isDesktop ? style.columnWrapper : {};

  return (
    <SectionContainer title="Detalhes da ordem">
      <FlatList
        key={numColumns}
        numColumns={numColumns}
        keyExtractor={(item) => item.testID}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ rowGap: 8 * numColumns }}
        data={sectionItems}
        {...(numColumns !== 1 && { columnWrapperStyle })}
        renderItem={({ item, index }) => {
          const isLast = numColumns === sectionItems.length && index === sectionItems.length - 1;

          return (
            <Box {...(!isLast && { flex: 1 / numColumns })}>
              <SectionItem {...item} isLast={isLast} />
            </Box>
          );
        }}
      />
    </SectionContainer>
  );
};
